import {HttpClient} from '@angular/common/http';

import {ApiService} from '../../shared';
import {Adjunto} from '../index';
import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class AdjuntosService extends ApiService<Adjunto>{

  protected dataKey = 'adjuntos';
  protected objectKey = 'ArchivosAdjuntos';
  protected sendObjectKey = 'adjuntos';
  protected reciveObjectKey = 'adjunto';
  protected sendObjectIdsKey = 'ids';

  constructor(protected httpClient: HttpClient) {
    super(Adjunto, httpClient, 'apiSeguroUrl');
  }
}
